import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';
@Component({
    selector: 'app-third-navbar',
    templateUrl: './third-navbar.component.html',
    styleUrls: ['./third-navbar.component.scss'],
    standalone: false
})
export class ThirdNavbarComponent {
  bannernode: Observable<any> = this.component.data$;

  userLoggedIn: any;
  userInfo: any;
  constructor(public component: CmsComponentData<CmsBannerComponent>,
    private cmsService:CmsService, 
    protected config: OccConfig,
    private cd:ChangeDetectorRef,
    private userInfoService:UserInfoService,
  ){
    
  }
  ngOnInit(): void{
    //for looged, loggedout
    this.userInfoService.userLoggedIn$.subscribe((res: any)=>{
      this.userLoggedIn = res;
      if(this.userLoggedIn){
        this.userInfoService.getUserData().subscribe((res: any)=>{
          if(res){
          this.userInfo=res;
          }
        });
      }
      this.cd.detectChanges();
    })
      //to get the current basesite   private userInfoService:UserInfoService,
 
      // this.baseSiteService.getActive().subscribe((siteId) => {
      //   this.currentSite = siteId;
      //   console.log(this.currentSite);
      // });
 }
}